import { ViewModelBase } from "../Base/ViewModelBase";

export class RoomUserModel extends ViewModelBase {
  public UserId?: number;

  public FullName?: string;

  public AvatarPath?: string;

  public AvatarUrl?: string;
}
